import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { StorageService } from "@core/storage-module/storage.service";
import { firstValueFrom } from "rxjs";
import { HttpApiService } from "./http-api.service";
import { UserService } from "./user/user.service";
import { config } from "@core/services/request-url.service";

@Injectable({ providedIn: 'root' })
export class LogoutService {
  constructor(
    private router: Router,
    private _HttpApiService: HttpApiService,
    private user: UserService,
    private storage: StorageService
  ) { }

  async logout(softDelete: boolean = false) {
    if (!softDelete) {
      // await firstValueFrom(this._HttpApiService.post(config.auth.logout));
    }

    this.user.resetLoginData();
    this.storage.clear();
    this.router.navigate(['/login']);
  }
}





//   /**
//    * Start session timeout tracking
//    * @param timeoutMinutes Timeout in minutes from API
//    */
//   startSessionTimeout(timeoutMinutes: number): void {
//     this.clearSessionTimers(); // Clear any existing timers

//     const sessionTimeoutMs = timeoutMinutes * 60 * 1000;
//     const warningTimeBeforeTimeout = 10000; // 10 seconds in ms

//     // Set timer to show warning 10 seconds before session expires
//     this.sessionTimeoutTimer = setTimeout(() => {
//       this.showTimeoutWarning();
//       this.startCountdown(10); // Start 10 second countdown
//     }, sessionTimeoutMs - warningTimeBeforeTimeout);
//   }

//   /**
//    * Show timeout warning toaster
//    */
//   private showTimeoutWarning(): void {
//     this.toastr.warning(
//       'Your session will expire in 10 seconds',
//       'Session Expiring',
//       {
//         timeOut: 10000, // Toast will disappear after 10 seconds
//         positionClass: 'toast-top-right',
//         disableTimeOut: false, // Allow toast to auto-close
//       }
//     );
//   }
//   /**
//    * Start visual countdown
//    * @param seconds Number of seconds to count down from
//    */
//   private startCountdown(seconds: number): void {
//     let remaining = seconds;
//     this._sessionTimeoutWarning.next(remaining);

//     this.countdownInterval = setInterval(() => {
//       remaining--;
//       this._sessionTimeoutWarning.next(remaining);

//       if (remaining <= 0) {
//         this.clearSessionTimers();
//         this.logout(true); // Soft logout
//       }
//     }, 1000);
//   }

//   /**
//    * Clear all session timers
//    */
//   private clearSessionTimers(): void {
//     if (this.sessionTimeoutTimer) {
//       clearTimeout(this.sessionTimeoutTimer);
//     }
//     if (this.countdownInterval) {
//       clearInterval(this.countdownInterval);
//     }
//     this._sessionTimeoutWarning.next(0);
//   }